<script>

const getHeaderMenu = (getTabulator) => {
    let menu = [];
    let columns = getTabulator.getColumns();

    for(let column of columns){
        // If the Title has String
        if (column.getDefinition().title) {
            //create checkbox element using font awesome icons
            let icon = document.createElement("i");
            icon.classList.add("bi");
            icon.classList.add(column.isVisible() ? "bi-check-square" : "bi-square");

            //build label
            let label = document.createElement("span");
            let title = document.createElement("span");

            title.textContent = " " + column.getDefinition().title;

            label.appendChild(icon);
            label.appendChild(title);

            //create menu item
            menu.push({
                label:label,
                action:(e) => {
                    //prevent menu closing
                    e.stopPropagation();

                    //toggle current column visibility
                    column.toggle();

                    //change menu item icon
                    if(column.isVisible()){
                        icon.classList.remove("bi-square");
                        icon.classList.add("bi-check-square");
                    }else{
                        icon.classList.remove("bi-check-square");
                        icon.classList.add("bi-square");
                    }
                    getTabulator.redraw()
                }
            });
        }
    }
    return menu;
}

export default getHeaderMenu

</script>


